import {Controller} from "@hotwired/stimulus"

const ROW_SELECTOR = ".license_row"
const PRICED_UNIT_SELECTOR = ".product_item_contractual_unit"
const MACHINE_TYPE_SELECTOR = ".product_item_machine_types"
const ARRAY_COUNT_SELECTOR = ".product_item_storage_arrays_nr"
const DURATION_SELECTOR = ".product_item_duration"
const COUNT_PLACEHOLDER = "%{count}"

export default class extends Controller {

  static values = {unconfigured: String, single: String, multiple: String}

  connect() {
    this.form = this.element.closest("form")
    this.tracking = this.canTrack()
    if (!this.tracking) return

    this.observeRows()
    this.render()
  }

  disconnect() {
    this.rowObserver?.disconnect()
  }

  refresh() {
    if (this.tracking) this.render()
  }

  canTrack() {
    if (!this.form) {
      console.error("quotes--bundle-array-count: no ancestor form, the bundle array count cannot be tracked", this.element)
      return false
    }

    if (!this.unconfiguredValue || !this.singleValue || !this.multipleValue.includes(COUNT_PLACEHOLDER)) {
      console.error("quotes--bundle-array-count: incomplete sentence translations", this.element.dataset)
      return false
    }

    return true
  }

  observeRows() {
    this.rowObserver = new MutationObserver(() => this.render())
    this.rowObserver.observe(this.form, {childList: true, subtree: true})
  }

  render() {
    const sentence = this.sentenceFor(this.configuredArrayCount())
    if (this.element.textContent === sentence) return

    this.element.textContent = sentence
  }

  sentenceFor(count) {
    if (count <= 0) return this.unconfiguredValue
    if (count === 1) return this.singleValue

    return this.multipleValue.replaceAll(COUNT_PLACEHOLDER, count)
  }

  configuredArrayCount() {
    return Array.from(this.form.querySelectorAll(ROW_SELECTOR)).reduce((total, row) => total + this.rowArrayCount(row), 0)
  }

  rowArrayCount(row) {
    if (!this.pricedUnitSelected(row) || this.durationAbovePricedRange(row)) return 0

    const arrayCountInput = row.querySelector(ARRAY_COUNT_SELECTOR)
    if (!arrayCountInput) {
      this.reportRowWithoutArrayCount(row)
      return 0
    }

    return this.integerValue(arrayCountInput.value)
  }

  reportRowWithoutArrayCount(row) {
    if (this.reportedRowWithoutArrayCount) return

    this.reportedRowWithoutArrayCount = true
    console.error("quotes--bundle-array-count: priced row without an array count input", row)
  }

  pricedUnitSelected(row) {
    const pricedUnitSelect = row.querySelector(PRICED_UNIT_SELECTOR) || row.querySelector(MACHINE_TYPE_SELECTOR)

    return Boolean(pricedUnitSelect?.value)
  }

  durationAbovePricedRange(row) {
    const durationInput = row.querySelector(DURATION_SELECTOR)
    if (!durationInput) return false

    const maximum = parseInt(durationInput.getAttribute("max"), 10)

    return !Number.isNaN(maximum) && this.integerValue(durationInput.value) > maximum
  }

  integerValue(value) {
    const number = parseInt(value, 10)

    return Number.isNaN(number) ? 0 : number
  }

}
